import { useState } from "react";
import { KeyRound, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api from "../../lib/api";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "../ui/dialog";

export function ChangePasswordDialog() {
  const [open, setOpen] = useState(false);
  const [cur, setCur] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const reset = () => { setCur(""); setNext(""); setConfirm(""); };

  const submit = async () => {
    if (next.length < 6) { toast.error("New password must be at least 6 characters"); return; }
    if (next !== confirm) { toast.error("New password and confirmation do not match"); return; }
    setBusy(true);
    try {
      await api.post("/auth/change-password", { current_password: cur, new_password: next });
      toast.success("Password changed successfully");
      reset(); setOpen(false);
    } catch (e) {
      toast.error(e.response?.data?.detail || "Could not change password");
    } finally { setBusy(false); }
  };

  return (
    <>
      <button data-testid="change-password-open" onClick={() => { reset(); setOpen(true); }}
        className="rounded-md p-2 text-slate-400 transition-colors hover:bg-slate-100 hover:text-teal-700" title="Change password">
        <KeyRound className="h-4 w-4" />
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-sm">
          <DialogHeader><DialogTitle className="font-display">Change Password</DialogTitle></DialogHeader>
          <div className="space-y-3">
            <div><Label>Current Password</Label><Input data-testid="cp-current" type="password" value={cur} onChange={(e) => setCur(e.target.value)} className="mt-1" /></div>
            <div><Label>New Password</Label><Input data-testid="cp-new" type="password" value={next} onChange={(e) => setNext(e.target.value)} className="mt-1" placeholder="min 6 characters" /></div>
            <div><Label>Confirm New Password</Label><Input data-testid="cp-confirm" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} className="mt-1" /></div>
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setOpen(false)}>Cancel</Button>
            <Button data-testid="cp-submit" disabled={busy} onClick={submit} className="bg-teal-600 hover:bg-teal-700">
              {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Update Password"}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
}
